import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import FormatUtils from '../common/formatUtils/FormatUtils';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import { setError } from '../common/toast/toast';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import SelectDefault from '../common/form/selectDefault';
import DateFormat from '../common/dateFormat/DateFormat';
import ColorUtils from '../common/colorUtils/ColorUtils';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import ButtonTable from '../common/table/buttonTable';
import consts from '../consts';

import {
	setModoTela, initForm, salvar
} from './ocorrenciaAutomaticaActions';

class OcorrenciaAutomaticaForm extends Component {

	state = {

	}

	componentDidMount() {

		const fileSelectorArquivo = document.createElement('input');
		fileSelectorArquivo.setAttribute('type', 'file');
		fileSelectorArquivo.addEventListener("change", (data) => {

			let reader = new FileReader();
			let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
			if (!file) {
				file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
			}

			if (file) {

				if (!file.type.includes('application/pdf')
					&& !file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
					setError('Selecione apenas (.PDF, .PNG, .JPG e .JPEG)');
					return;
				}

				reader.onloadend = () => {

					let lista = (this.props.formularioValues.arquivo || []).map(item => item);
					lista.push({
						arquivo_base64: reader.result
					});

					this.props.initForm({
						...this.props.formularioValues,
						arquivo: lista
					});

				}

				reader.readAsDataURL(file);

			}
		});

		this.fileSelectorArquivo = fileSelectorArquivo;
	}

    componentWillMount() {

		// this.props.getListaHistorico(this.props.formularioValues.id);

    }

    render() {

		let readOnly = this.props.excluir || this.props.visualizacao ? 'readOnly' : '';

		const motoristasSelecionados = (this.props.listaMotorista || [])
			.filter(motorista =>
				(this.props.formularioValues.ids_motoristas || []).includes(motorista.id)
			);

		const cpfsMotoristasCadastrados = motoristasSelecionados
			.filter(motorista => motorista && motorista.cpf)
			.map(motorista => motorista.cpf);

		const conjuntos = this.props.formularioValues.conjuntos || [];

		const styles = {
			container: {
				width: '100%',
				marginTop: 4,
				marginBottom: 16,
				border: '1px solid #e5e7eb',
				borderRadius: 8,
				overflow: 'hidden',
				background: '#fff'
			},
			header: {
				display: 'grid',
				gridTemplateColumns: '120px 160px 1fr 150px 140px',
				alignItems: 'center',
				gap: 12,
				padding: '10px 14px',
				background: '#f9fafb',
				borderBottom: '1px solid #e5e7eb',
				fontSize: 12,
				fontWeight: 600,
				color: '#000000',
				letterSpacing: '0.04em'
			},
			row: {
				display: 'grid',
				gridTemplateColumns: '120px 160px 1fr 150px 140px',
				alignItems: 'center',
				gap: 12,
				padding: '12px 14px',
				borderBottom: '1px solid #f1f5f9'
			},
			rowAlerta: {
				background: '#fff7ed'
			},
			cellHeader: {
				textAlign: 'center'
			},
			cell: {
				fontSize: 13,
				color: '#374151',
				wordBreak: 'break-word',
				textAlign: 'center'
			},
			placa: {
				fontWeight: 700,
				color: '#111827',
				letterSpacing: '0.04em'
			},
			status: {
				display: 'inline-flex',
				alignItems: 'center',
				justifyContent: 'center',
				padding: '4px 10px',
				borderRadius: 999,
				fontSize: 12,
				fontWeight: 600,
				whiteSpace: 'nowrap'
			},
			statusOk: {
				color: '#166534',
				background: '#dcfce7'
			},
			statusAlerta: {
				color: '#9a3412',
				background: '#ffedd5'
			}
		};

        return (
			<>				
				<ContentCard>					
					<Form event={this.props.handleSubmit}>
						{this.props.formularioValues.totalLote > 0 &&
						<ContentCardHeader>
							<Row alignCenter style={{ marginBottom: 8, fontSize: 16 }}>
								<strong>Validação em lote:</strong>&nbsp;
								{this.props.formularioValues.executandoLote} de {this.props.formularioValues.totalLote}
							</Row>

							<div
								style={{
									width: '100%',
									height: 12,
									background: '#E5E7EB',
									borderRadius: 999,
									overflow: 'hidden',
									marginBottom: 16
								}}
							>
								<div
									style={{
										width: `${(this.props.formularioValues.executandoLote / this.props.formularioValues.totalLote) * 100}%`,
										height: '100%',
										background: '#2563EB',
										transition: 'width .3s ease'
									}}
								/>
							</div>
						</ContentCardHeader>}
						<ContentCardBody>
							{this.props.formularioValues.status !== 'Pendente' &&
							<span
								style={{
									display: 'inline-block',
									padding: '4px 10px',
									borderRadius: '999px',
									fontSize: 16,
									fontWeight: 600,
									marginBottom: 16,
									color:
										this.props.formularioValues.status === 'Aprovada'
											? '#166534'
											: this.props.formularioValues.status === 'Reprovada'
												? '#991B1B'
												: '#374151',
									backgroundColor:
										this.props.formularioValues.status === 'Aprovada'
											? '#bce6ca'
											: this.props.formularioValues.status === 'Reprovada'
												? '#e8b3b3'
												: '#cfd1d4',
								}}
							>
								{this.props.formularioValues.status}
							</span>}
							<Row>
								<LabelAndInput
									name='shipping'
									label='Shipping' placeholder='Informe'
									cols='12 12 6 4'
									maxWidth={150}
									readOnly={'readOnly'}
									value={this.props.formularioValues.shipping}
									onChange={value => {}} />


								<LabelAndInput
									name='romaneio'
									label='Romaneio' placeholder='Informe'
									cols='12 12 6 4'
									maxWidth={150}
									readOnly={'readOnly'}
									value={this.props.formularioValues.romaneio}
									onChange={value => {}} />
								
								<LabelAndInput
									name='id_ocorrencia_kmm'
									label='ID KMM' placeholder='Informe'
									cols='12 12 6 4'
									maxWidth={150}
									readOnly={'readOnly'}
									value={this.props.formularioValues.id_ocorrencia_kmm}
									onChange={value => {}} />

								<LabelAndInput
									name='datahora_inicio'
									label='Data e Hora' placeholder='Informe a data e hora'
									cols='12 12 6 4'
									maxWidth={180}
									readOnly={'readOnly'}
									value={DateFormat.formatarDataHoraSqlParaTela(this.props.formularioValues.datahora_inicio)}
									onChange={value => {
										
									}} />

								<LabelAndInput
									name='usuario_inclusao_kmm'
									label='Usuário KMM' placeholder='Informe'
									cols='12 12 6 4'
									maxWidth={200}
									readOnly={'readOnly'}
									value={this.props.formularioValues.usuario_inclusao_kmm}
									onChange={value => {}} />
							</Row>
							<Row>		
								<Select
									name='id_tipo'
									options={this.props.listaTipo.map(item => ({ ...item, valor: `${item.valor} (${item.id})`}))}
									label='Tipo'
									cols='12 12 6 4'
									placeholder='Selecione o tipo'
									readOnly={'readOnly'}
									value={this.props.formularioValues.id_tipo}
									onChange={index => {

									}} />

								<Select
									name='ids_motoristas'
									options={this.props.listaMotorista}
									label='Motoristas'
									cols='12 12 12 12'
									placeholder='Selecione'
									multiple
									readOnly={readOnly}
									value={this.props.formularioValues.ids_motoristas}
									onChange={values => {
										this.props.initForm({
											...this.props.formularioValues,
											ids_motoristas: values.map(item => item.value)
										});
									}} />
							</Row>
							
							{conjuntos.length > 0 && (
								<Row>
									<Grid cols="12 12 12 12">
										<div style={styles.container}>
											<div style={styles.header}>
												<div style={{ ...styles.cellHeader }}>Placa</div>
												<div style={{ ...styles.cellHeader }}>CPF</div>
												<div style={{ ...styles.cellHeader }}>Motorista</div>
												<div style={{ ...styles.cellHeader }}>Data Admissão</div>
												<div style={{ ...styles.cellHeader }}>Status</div>
											</div>

											{conjuntos.map((conjunto, i) => {
												const cadastrado = cpfsMotoristasCadastrados.includes(conjunto.cpf_motorista);

												return (
													<div
														key={`${conjunto.placa}-${conjunto.cpf_motorista}-${i}`}
														style={{
															...styles.row,
															...(!cadastrado ? styles.rowAlerta : {}),
															borderBottom: i === conjuntos.length - 1 ? 'none' : styles.row.borderBottom
														}}
													>
														<div style={{ ...styles.cell, ...styles.placa }}>
															{conjunto.placa || '-'}
														</div>

														<div style={styles.cell}>
															{conjunto.cpf_motorista || '-'}
														</div>

														<div style={styles.cell}>
															{conjunto.nome_motorista || '-'}
														</div>

														<div style={styles.cell}>
															{DateFormat.formatarDataSqlParaTela(conjunto.data_admissao)}
														</div>

														<div style={styles.cell}>
															<span
																style={{
																	...styles.status,
																	...(cadastrado ? styles.statusOk : styles.statusAlerta)
																}}
															>
																{cadastrado ? 'Cadastrado' : 'Não cadastrado'}
															</span>
														</div>
													</div>
												);
											})}
										</div>
									</Grid>
								</Row>
							)}

							<Row>							
								<LabelAndInput
									name='observacao'
									component={LabelAndInput}
									label='Observação' placeholder='Informe'
									cols='12 12 12 12'
									readOnly={'readOnly'}
									value={this.props.formularioValues.observacao}
									onChange={index => {
										
									}} />

								{this.props.formularioValues.comentario_original != this.props.formularioValues.comentario &&
								<LabelAndInput
									name='comentario_original'
									component={LabelAndInput}
									label='Descrição Original' placeholder='Informe'
									cols='12 12 12 12'
									readOnly={'readOnly'}
									value={this.props.formularioValues.comentario_original}
									onChange={index => {
										
									}} />}

								<Field
									name='comentario'
									component={LabelAndInput}
									label='Descrição' placeholder='Informe'
									cols='12 12 12 12'
									readOnly={readOnly} />

								<Field
									name='comentario_aprovacao'
									component={LabelAndInput}
									label='Comentário' placeholder='Informe'
									cols='12 12 12 12'
									readOnly={readOnly} />

							</Row>
							
							{this.props.validacao &&
							<Row>
								<Grid cols='12 12 12 12'>
									<label>Arquivo</label>
								</Grid>
								{(this.props.formularioValues.arquivo || []).map(arquivo => (
									<div style={{ display: 'flex', flexDirection: 'column', marginLeft: 8 }}>
										<span class="btn btn-outline-primary fileinput-button dz-clickable">
											<img src={arquivo.arquivo_base64 ? pdfAdicionado : (arquivo.arquivo ? pdfAdicionado : pdfAdd)} style={{ height: 30 }} />
										</span>
										<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
											<button
												type='button'
												class='btn btn-flat btn-outline-primary'
												style={{ width: '48%' }}
												disabled={arquivo.arquivo_base64 ? true : false}
												onClick={() => {
													window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
												}}>
												<i class='fas fa-download'></i>
											</button>

											<button
												type='button'
												class='btn btn-flat btn-outline-danger'
												style={{ width: '48%' }}
												disabled={readOnly}
												onClick={() => {
													this.props.initForm({
														...this.props.formularioValues,
														arquivo: this.props.formularioValues.arquivo.filter(item => item != arquivo)
													});
												}}>
												<i class='fas fa-trash-alt'></i>
											</button>
										</div>
									</div>
								))}

								{!readOnly &&
								<span class="btn btn-outline-primary fileinput-button dz-clickable"
									style={{ marginLeft: 8 }}
									onClick={() => this.fileSelectorArquivo.click()}>
									<img src={pdfAdd} style={{ height: 30 }} />
								</span>}
							</Row>}

						</ContentCardBody>
						<ContentCardFooter>
							<Row alignCenter>
								{this.props.excluir &&
								<Grid cols='6 6 4 3'>									
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								</Grid>}
								{(!this.props.excluir && !this.props.validacao && !this.props.visualizacao) &&
								<Grid cols='6 6 4 3'>
									<Button
										text='Salvar'
										submit
										type={'success'}
										icon={'fa fa-check'} />
								</Grid>}

								{this.props.validacao &&
								<Grid cols='6 6 4 3'>
									<Button
										text='Reprovar'
										type={'danger'}
										icon={'fa fa-chevron-left'}
										event={() => this.props.salvar({
											...this.props.formularioValues,
											reprovada: true
										})} />
								</Grid>}

								{this.props.validacao &&
								<Grid cols='6 6 4 3'>
									<Button
										text='Aprovar'
										type={'success'}
										icon={'fa fa-chevron-left'}
										event={() => this.props.salvar({
											...this.props.formularioValues,
											aprovar: true
										})} />
								</Grid>}

								<Grid cols='6 6 4 3'>
									<Button
										text='Voltar'
										type={'warning'}
										icon={'fa fa-chevron-left'}
										event={() => this.props.setModoTela('lista')} />
								</Grid>
							</Row>
						</ContentCardFooter>
					</Form>
				</ContentCard>
			</>
        )
    }

}

OcorrenciaAutomaticaForm = reduxForm({form: 'ocorrenciaAutomaticaForm', destroyOnUnmount: false})(OcorrenciaAutomaticaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('ocorrenciaAutomaticaForm')(state),
	registro: state.ocorrenciaAutomatica.registro,
	listaTipo: state.ocorrenciaAutomatica.listaTipo,
	listaMotorista: state.ocorrenciaAutomatica.listaMotorista,
	listaUsuario: state.ocorrenciaAutomatica.listaUsuario
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar, 
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(OcorrenciaAutomaticaForm);